// Gilded Rails — Tier-A bundle (server/test-safe). NO image imports. Generated by create-mod.
import { RULES } from '../dominion/rules';
import { BOARD_SPACES, COLOR_GROUPS } from '../dominion/board';
import { CHANCE_CARDS, COMMUNITY_CARDS } from '../dominion/cards';
import { CHARACTERS_DATA, getCharacterById, getStartingMoney } from './characters-data';
import { CHARACTER_LORE, getLoreById } from './lore';
import data from './gilded-rails.data.json';

export const gildedRailsData = {
  id: 'gilded-rails',
  name: "Gilded Rails",
  tagline: "Rail barons carve up a booming frontier line.",
  version: "1.0.0",

  rules: RULES,
  characters: CHARACTERS_DATA,
  board: { spaces: BOARD_SPACES, colorGroups: COLOR_GROUPS },
  cards: { chance: CHANCE_CARDS, community: COMMUNITY_CARDS },
  lore: CHARACTER_LORE,

  getCharacterById,
  getStartingMoney,
  getLoreById,

  maps: [data.map],
  worlds: [],
};

export default gildedRailsData;
